<template>
  <div class="adasRecord">
    <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini"
      @sort-change="sortChange" @selection-change="handleSelectionChange"
    >
      <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80 : 50"
        align="center" :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column prop="orderNumber" label="工单号" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.orderNumber"
            placement="top" min-width="100px" :open-delay="300"
          >
            <span v-if="scope.row.orderNumber" class="textOverflow">
              {{ scope.row.orderNumber }}
            </span>
          </el-tooltip>
          <span v-if="!scope.row.orderNumber">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="sapOrderNumber" label="SAP工单" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.sapOrderNumber"
            placement="top" min-width="100px" :open-delay="300"
          >
            <span v-if="scope.row.sapOrderNumber" class="textOverflow">
              {{ scope.row.sapOrderNumber }}
            </span>
          </el-tooltip>
          <span v-if="!scope.row.sapOrderNumber">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="product" label="产品型号" align="center">
        <template slot-scope="scope">
          <span class="textOverflow">
              {{ scope.row.product ? scope.row.product : "-" }}
            </span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="工单数量" align="center">
        <template slot-scope="scope">          
          <span class="textOverflow">
            {{ scope.row.quantity }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="current" label="已下载数量" align="center">
        <template slot-scope="scope">          
          <span class="textOverflow">
            {{ scope.row.current }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="startDateTime" label="开始下载时间" align="center">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.startDateTime" class="item" effect="dark" :content="scope.row.startDateTime"
            placement="top" min-width="100px" :open-delay="300"
          >
            <span class="textOverflow">
              {{ scope.row.startDateTime }}
            </span>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="completeDateTime" label="下载完成时间" align="center">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.completeDateTime" class="item" effect="dark" :content="scope.row.completeDateTime"
            placement="top" min-width="100px" :open-delay="300"
          >
            <span class="textOverflow">
              {{ scope.row.completeDateTime }}
            </span>
          </el-tooltip>
          <el-tooltip v-else-if="scope.row.notes" class="item" effect="dark" :content="scope.row.notes"
            placement="top" min-width="100px" :open-delay="300"
          >
            <span class="textOverflow yiguoqi">
              {{ scope.row.notes }}
            </span>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="createUser" label="业务员" align="center">
        <template slot-scope="scope">          
          <span class="textOverflow">
              {{ scope.row.createUser ? (scope.row.createUser.name+"("+scope.row.createUser.employeeNum+")") : "-" }}
            </span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="onSearch"
    ></pagination>
  </div>
</template>

<script>

import pagination from "@/components/pagination.vue";
import {
  apiAdasRecordSearch,
} from "@/api/adasRecord.js";
export default {
  components: {
    pagination
  },
  props: {
    adasRecordSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: true,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      multipleSelection: [],
    };
  },
  methods: {
    // 表格数据
    async onSearch() {      
      const res = await apiAdasRecordSearch({
        ...this.adasRecordSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
      }
    },
    // 产品列表表格导出
    tableExport() {
      this.$confirm(`确定导出ADAS下载记录吗？`, `导出`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = {};
        res = await apiAdasRecordSearch({
          ...this.adasRecordSearchForm,
          export: true
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      });
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.onSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.onSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.onSearch();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
};
</script>

<style lang="less" scoped>
.yiguoqi {
  margin-right: 3px;
  color: #f56c6c
}
.adasRecord {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.item {
  margin-right: 2px;
  margin-left: 2px;
}
</style>
